import { render } from "./AssistenzaTecnicaConversation.vue?vue&type=template&id=35ce2972&scoped=true"
import script from "./AssistenzaTecnicaConversation.vue?vue&type=script&lang=js"
export * from "./AssistenzaTecnicaConversation.vue?vue&type=script&lang=js"

import "./AssistenzaTecnicaConversation.vue?vue&type=style&index=0&id=35ce2972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ce2972"]])

export default __exports__